module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-700-bold-italic-ebb6cb06c9ad2901fe8dffdd459f400d.woff";